import {useEffect, useState, useRef, useCallback} from 'react';
import RewardTable from "./RewardTable";
import '../css/rewardSlider.css'

function RewardSlider({sectionData, data}) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const wrapperRef = useRef(null);
    const isScrolling = useRef(false);

    const goTo = useCallback((idx) => {
        if (idx >= 0 && idx < sectionData.length) {
            setCurrentIndex(idx);
        }
    }, [sectionData.length]);

    // 마우스 휠로 슬라이드 이동
    useEffect(() => {
        const handleWheel = (e) => {
            if (isScrolling.current) return;

            const wrapper = wrapperRef.current;
            const activeSlide = wrapper.querySelectorAll('.slider-slide')[currentIndex];

            // 현재 슬라이드에서 스크롤 가능한 경우: 슬라이드 이동 금지
            if (
                activeSlide.scrollHeight > activeSlide.clientHeight &&
                (
                    (e.deltaY > 0 && activeSlide.scrollTop + activeSlide.clientHeight < activeSlide.scrollHeight) ||
                    (e.deltaY < 0 && activeSlide.scrollTop > 0)
                )
            ) {
                return; // 내부 스크롤만 처리
            }

            isScrolling.current = true;

            if (e.deltaY > 0) {
                goTo(currentIndex + 1);
            } else {
                goTo(currentIndex - 1);
            }

            setTimeout(() => {
                isScrolling.current = false;
            }, 600);
        };

        const wrapper = wrapperRef.current;
        wrapper.addEventListener('wheel', handleWheel);

        return () => {
            wrapper.removeEventListener('wheel', handleWheel);
        };
    }, [currentIndex, sectionData.length, goTo]);

    // 터치 스와이프로 슬라이드 이동
    useEffect(() => {
        let startY = 0;

        const handleTouchStart = (e) => {
            startY = e.touches[0].clientY;
        };

        const handleTouchEnd = (e) => {
            const endY = e.changedTouches[0].clientY;
            const deltaY = startY - endY;

            if (Math.abs(deltaY) > 50) {
                if (deltaY > 0) {
                    goTo(currentIndex + 1);
                } else {
                    goTo(currentIndex - 1);
                }
            }
        };

        const wrapper = wrapperRef.current;
        wrapper.addEventListener('touchstart', handleTouchStart);
        wrapper.addEventListener('touchend', handleTouchEnd);

        return () => {
            wrapper.removeEventListener('touchstart', handleTouchStart);
            wrapper.removeEventListener('touchend', handleTouchEnd);
        };
    }, [currentIndex, sectionData.length, goTo]);

    return (
        <div className="slider-wrapper" ref={wrapperRef}>
            <div
                className="slider-track"
                style={{
                    transform: `translateY(-${currentIndex * 100}vh)`,
                    height: `${sectionData.length * 100}vh`,
                }}
            >

                {sectionData.map((info, i) => (
                    <div className="slider-slide" key={i}>
                        <RewardTable
                            data={data}
                            sectionName={info.sectionName}
                            sectionList={info.section}
                            viewList={info.view}
                        />
                    </div>
                ))}
            </div>

            <div className="slider-dots">
                {sectionData.map((_, i) => (
                    <span
                        key={i}
                        className={`dot ${i === currentIndex ? 'active' : ''}`}
                        onClick={() => goTo(i)}
                    />
                ))}
            </div>
        </div>
    );
}

export default RewardSlider;